<template>
  <div class="new-vip-recharge-page">
    <div class="ceiling">
      <home-top></home-top>
    </div>
    <div class="content-wrapper">
      <div class="w-1400 content-inner">
        <!--  -->
        <div class="vip-main-content">
          <!-- VIP等级选择 -->
          <div class="vip-level-selector">
            <h2 class="level-title">选择您的会员等级</h2>
            <div class="level-cards">
              <div :class="['level-card', { active: selectedLevel === 'vip' }]" @click="selectLevel('vip')">
                <div class="level-header">
                  <i :class="vipConfig.levels.vip.icon" :style="{ color: vipConfig.levels.vip.iconColor }"></i>
                  <h3>{{ vipConfig.levels.vip.name }}</h3>
                </div>
                <div class="level-price">
                  <span>¥</span>{{ configInfo.vip_acount }}/年
                </div>
                <ul class="level-features">
                  <li v-for="feature in vipConfig.levels.vip.features" :key="feature">
                    <i class="el-icon-check"></i> {{ feature }}
                  </li>
                </ul>
              </div>

              <div :class="['level-card', { active: selectedLevel === 'svip' }]" @click="selectLevel('svip')">
                <div class="level-header">
                  <i :class="vipConfig.levels.svip.icon" :style="{ color: vipConfig.levels.svip.iconColor }"></i>
                  <h3>{{ vipConfig.levels.svip.name }}</h3>
                  <span v-if="vipConfig.levels.svip.badge" class="svip-badge">{{ vipConfig.levels.svip.badge }}</span>
                </div>
                <div class="level-price">
                  <span>¥</span>{{ configInfo.svip_acount }}/年
                </div>
                <ul class="level-features">
                  <li v-for="feature in vipConfig.levels.svip.features" :key="feature">
                    <i class="el-icon-check"></i> {{ feature }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 支付区域 -->
          <div class="new-payment-section">
            <div class="pay-body">
              <div class="pay-item">
                <div class="pay-item-title">
                  <!--                  <span :class="['pay-type', { active: selectedPayType === 'alipay' }]" @click="selectPay('alipay')">-->
                  <!--                    支付宝支付-->
                  <!--                  </span>-->
                  <span :class="['pay-type', { active: selectedPayType === 'wechat' }]" @click="selectPay('wechat')">
                    微信支付
                  </span>
                  <span :class="['pay-type', { active: selectedPayType === 'lineDown' }]"
                        @click="selectPay('lineDown')">
                    线下汇款
                  </span>

                </div>
              </div>
              <div class="pay-code">
                <div class="pay-code-title">
                  支付金额：{{ currentPrice }}元
                </div>
                <div v-if="selectedPayType != 'lineDown'">
                  <div v-if="codeLoading" class=" sizre-20">
                    <i class="el-icon-loading"></i>
                  </div>
                  <canvas class="qrcode" id="qrcode" ref="qrcode"></canvas>
                </div>
                <div class="pay-code-tip" v-if="selectedPayType != 'lineDown'">
                  请使用
                  <span class="pay-code-tip-text">{{
                      selectedPayType === "wechat" ? "微信" : "微信"
                    }}</span>
                  扫描二维码完成支付
                </div>
                <div v-else class="pay-inner">
                  <!-- <div class="pay-code-title"> 支付金额：{{ detail.total_price || total_price }}元</div> -->
                  <el-form v-model="formData" :rules="formRules" class="pay-form" label-width="100px" ref="formRules">
                    <el-form-item label="汇款方式">
                      <el-radio-group v-model="formData.pay_type" prop="pay_type">
                        <el-radio label="remit_alipay">支付宝汇款</el-radio>
                        <el-radio label="remit_bank">银行汇款</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="支付宝二维码" v-if="formData.pay_type == 'remit_alipay'">
                      <el-image style="width: 120px; height: 120px" :src="configInfo.pay_alipay"
                                fit="scale-down"></el-image>
                    </el-form-item>
                    <div v-else>

                      <el-form-item label="账户名称">
                        {{ configInfo.pay_name }}
                        <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_name)">
                          <i class="el-icon-copy-document"></i></el-button>
                      </el-form-item>

                      <el-form-item label="银行帐号">
                        {{ configInfo.pay_bank }}
                        <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_bank)">
                          <i class="el-icon-copy-document"></i></el-button>
                      </el-form-item>

                      <el-form-item label="开户行">
                        {{ configInfo.pay_account }}
                        <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_account)">
                          <i class="el-icon-copy-document"></i></el-button>
                      </el-form-item>

                    </div>
                    <el-form-item label="汇款凭证" v-model="formData.pay_image" prop="pay_image">
                      <ImageUpload :maxCount="1" @change="changeImage"></ImageUpload>
                    </el-form-item>
                  </el-form>
                  <el-button type="primary" class="button-style" @click="save">
                    提交
                  </el-button>
                </div>

                <div class="login-box-text">
                  <el-checkbox v-model="disAgree" @change="changeAgree"></el-checkbox>
                  <div class="text">
                    已阅读并同意
                    <span class="agreement-link" @click.stop="showAgreement(3)">《{{
                        selectedLevel === 'vip' ? 'VIP' : 'SVIP'
                      }}会员协议》</span>和<span class="agreement-link" @click.stop="showAgreement(15)">《{{
                      selectedLevel === 'vip' ? 'VIP' : 'SVIP'
                    }}合同》</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import {member, getConfigByKey, getConfigByKeyPost} from '@/api/modules/common';
import homeTop from '../../../components/public/home-top.vue';
import HomeFooter from '../../../components/public/home-footer.vue';
import QRCode from "qrcode";
import ImageUpload from '@/components/public/ImageUpload.vue';
import {
  unifiedPayment,
} from "@/api/modules/user";
import VIP_CONFIG from '@/config/vipConfig';

export default {
  components: {homeTop, HomeFooter, ImageUpload},
  name: 'VipRecharge',
  data() {
    return {
      changeFlag: 0,//是否重新提交
      disAgree: false,
      codeLoading: false,
      selectedLevel: 'vip', // 默认选择VIP
      selectedPayType: '',
      order_id: "",
      pollingInterval: null,
      vipConfig: VIP_CONFIG,
      formData: {
        pay_type: "remit_alipay",
        pay_image: []
      },
      formRules: {
        pay_image: [
          {required: true, message: '请上传汇款凭证', trigger: 'blur'}
        ]
      },
      pay_name: '',
      pay_account: '',
      pay_bank: '',
      pay_alipay: ''
    };
  },
  computed: {
    userinfo() {
      return this.$store.getters.userInfo;
    },
    currentPrice() {
      return this.selectedLevel === 'vip' ? this.configInfo.vip_acount : this.configInfo.svip_acount;
    },
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    this.generateOrder();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    handleCopy(text) {
      this.$utils.copyText(text).then(res => {
        this.$message.success('复制成功');
      })
    },
    // 点击是否同意协议
    changeAgree(val) {
      if (!this.mixCheckUserAudit()) {
        return
      }
      this.disAgree = val;
      if (val) {
        this.startPolling()
        if (this.selectedPayType === 'wechat') {
          this.selectPay()
        }
      } else {
        this.stopPolling2()
      }
    },

    // 上传图片
    changeImage(e) {
      this.formData.pay_image = e[0]
    },

    // 线下支付提交成功
    save() {
      if (this.formData.pay_image.length == 0) {
        this.$message.error({
          message: '请上传汇款凭证',
          offset: 300
        })
        return
      }
      if (this.formData.pay_type && this.formData.pay_image) {
        unifiedPayment({
          pay_type: this.formData.pay_type,
          pay_image: this.formData.pay_image,
          order_id: this.order_id,
          form_field: 'member'
        }).then(res => {
          if (res.data.code == 10000) {
            this.$message.success(
                {
                  message: res.data.message,
                  offset: 300
                }
            )
            this.stopPolling();
            this.$store.dispatch('GET_USER_INFO')
          }
        })

      } else {
        this.$message.error({
          message: '请完善信息后提交！',
          offset: 300
        })
      }
    },

    selectLevel(level) {
      this.selectedLevel = level;
      // 重新生成订单
      this.generateOrder();
    },

    showAgreement(id) {
      this.$router.push('/agreement/agreement?id=' + id);
    },

    async generateOrder() {
      // 根据选择的等级生成订单
      let res = await member({member_type: this.selectedLevel === 'vip' ? 1 : 2});
      this.order_id = res.data.data;
    },

    async selectPay(type) {
      if (!this.mixCheckUserAudit()) {
        return
      }
      if (this.userinfo.vip_status === 1) {
        this.stopPolling();
        this.$message.success('恭喜您，VIP已开通！');
        return
      }
      if (!this.disAgree) {
        this.$message.error({
          message: '请阅读并同意vip会员协议和vip合同',
          offset: 300
        })
        return
      }

      this.selectedPayType = type;
      if (type == 'lineDown') {
        return
      }
      let data = {
        pay_type: this.selectedPayType == 'wechat' ? 'wechat_native' : 'alipay',
        order_id: this.order_id,
        form_field: 'member',
        level: this.selectedLevel, // 添加等级参数
      };
      this.codeLoading = true;
      let res = await unifiedPayment(data)
      if (res.data.code === 10000) {

        if (this.selectedPayType === "wechat") {
          this.getCode(res.data.data.code_url);
        } else {
          this.getCode(res.data.data.qr_code);
        }
      } else {
        this.$message.error(res.data.message);
      }
    },

    async getCode(url) {
      try {
        await QRCode.toCanvas(this.$refs.qrcode, url, {
          width: 200,
          margin: 2,
          color: "#000000",
          background: "#ffffff",
        });
        this.codeLoading = false;
      } catch (err) {
        console.error("生成二维码失败:", err);
      }
    },

    startPolling() {
      if (!this.pollingInterval) {
        this.pollingInterval = setInterval(() => {
          this.$store.dispatch('GET_USER_INFO')
          if (this.userinfo.vip_status == 1 || this.userinfo.member_pay_submit && !this.changeFlag) {
            this.stopPolling()
          }
        }, 1000);
      }
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.$router.push('/vip/vipSuc');
        this.pollingInterval = null;
      }
    },
    stopPolling2(){
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.login-box-text {
  margin-top: 20px;
  display: flex;
  align-items: center;
  font-size:14px;
  gap:5px;
}

.pay-inner {
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;

  .button-style {
    width: 100%;
  }
}

.agreement-link {
  color: #667eea;
  cursor: pointer;
  // text-decoration: underline;
}

// VIP等级选择器样式
.vip-level-selector {
  margin-bottom: 40px;

  .level-title {
    font-size: 32px;
    color: #333d4b;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 700;
  }

  .level-cards {
    display: flex;
    gap: 30px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .level-card {
    background: #ffffff;
    border: 2px solid #e0e0e0;
    border-radius: 15px;
    padding: 30px;
    width: 300px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }

    &.active {
      border-color: #409eff;
      box-shadow: 0 15px 40px rgba(64, 158, 255, 0.2);
      transform: translateY(-5px);
    }

    .level-header {
      text-align: center;
      margin-bottom: 20px;
      position: relative;

      i {
        font-size: 30px;
        margin-bottom: 10px;
      }

      h3 {
        font-size: 24px;
        color: #333;
        margin: 0;
        font-weight: 600;
      }

      .svip-badge {
        position: absolute;
        top: -10px;
        right: -10px;
        background: linear-gradient(135deg, #ff6b35, #f7931e);
        color: white;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: bold;
        box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
      }
    }

    .level-price {
      text-align: center;
      margin-bottom: 25px;
      font-size: 36px;
      font-weight: 700;
      color: #409eff;

      span {
        font-size: 20px;
        font-weight: normal;
      }
    }

    .level-features {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        font-size: 14px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        color: #666;

        .el-icon-check {
          margin-right: 8px;
          color: #67c23a;
          font-size: 16px;
        }
      }
    }
  }
}

.sizre-20 {
  font-size: 40px;
  position: absolute;
  line-height: 212px;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  padding-left: 10px;
  /* 垂直居中 */
  width: 212px;
  height: 212px;
  background: #ffffff;
  border-radius: 24px;
  opacity: 0.8;
}

.pay-item-title {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin: 32px 0 24px 0;
}

.qrcode {
  width: 200px;
  height: 200px;
}

.pay-type {
  padding: 12px 36px;
  border: 2px solid #e0e0e0;
  border-radius: 28px;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  background: #f7faff;
  transition: all 0.2s;
  user-select: none;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(12, 96, 230, 0.04);
}

.pay-type.active {
  border-color: #0c60e6;
  background: #e8ebf5;
  color: #0c60e6;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(12, 96, 230, 0.1);
}

.pay-type:not(.active):hover {
  border-color: #bdbdbd;
  background: #f0f4fa;
}

.pay-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 24px;
}

.pay-code canvas {
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(12, 96, 230, 0.08);
  background: #fff;
  padding: 12px;
}

.pay-code-tip {
  margin-top: 16px;
  color: #888;
  font-size: 15px;
  letter-spacing: 1px;
}

.pay-code-title {
  font-size: 22px;
  color: #0c60e6;
  font-weight: bold;
  margin-bottom: 18px;
  text-align: center;
  letter-spacing: 1px;
}

.new-vip-recharge-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #e9edf2;
  /* 调整为更沉稳的浅蓝灰色 */
}

.ceiling {
  flex-shrink: 0;
}

.content-wrapper {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 62px);
  // padding: 40px 0;
  background: url('../../../static/index/message-bj.png');
  background-size: 100% 100%;
  // background: linear-gradient(to bottom, #549fe9, #034AE5); /* 调整为沉稳的蓝灰色渐变 */
  // background: #549fe9;
  /* 调整为沉稳的蓝灰色渐变 */
}

.w-1200 {
  width: 1200px;
  margin: 0 auto;
}

.content-inner {
  border-radius: 10px;
  height: calc(100vh - 62px);
  // box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
  // padding: 50px 60px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* align-items: center; // 暂时移除，让vip-main-content自身水平居中 */
}

.new-back-button {
  position: absolute;
  top: 30px;
  left: 30px;
  background: #e9eff5;
  color: #5a6b7d;
  border: 1px solid #d8e0e6;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease-out;

  &:hover {
    background: #e0e5ed;
    color: #409eff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
}

.new-page-title {
  font-size: 38px;
  color: #333d4b;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 700;
  letter-spacing: 1.5px;
  position: relative;
  text-shadow: none;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -15px;
    transform: translateX(-50%);
    width: 90px;
    height: 3px;
    background: #409eff;
    border-radius: 1.5px;
  }
}

.vip-main-content {
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* 水平居中内部内容 */
  margin-top: auto;
  /* 垂直居中关键 */
  margin-bottom: auto;
  /* 垂直居中关键 */
}

.new-vip-price-card {
  background: #3972ee;
  /* 沉稳的蓝色渐变 */
  border-radius: 10px;
  padding: 50px;
  color: #ffffff;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  transform: none;
  transition: all 0.4s ease-out;
  margin: 0;
  /* 移除自动margin，由父容器flex居中 */
  max-width: 600px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35);
  }

  .price-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;

    .vip-icon {
      font-size: 40px;
      margin-right: 20px;
      color: #ffd700;
    }

    h2 {
      font-size: 30px;
      font-weight: 700;
    }
  }

  .price-value {
    font-size: 80px;
    font-weight: 800;
    margin-bottom: 20px;

    span {
      font-size: 40px;
      font-weight: normal;
      margin-right: 8px;
    }
  }

  .price-desc {
    font-size: 17px;
    margin-bottom: 35px;
    opacity: 0.9;
  }

  .features-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 15px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.95;

      .el-icon-check {
        margin-right: 10px;
        color: #8cffb3;
      }
    }
  }
}

.new-payment-section {
  width: 100%;
  max-width: 600px;

  h3 {
    font-size: 26px;
    color: #333d4b;
    margin-bottom: 30px;
    text-align: center;
    font-weight: 600;
  }
}

.payment-options-grid {
  display: flex;
  justify-content: center;
  gap: 35px;
  flex-wrap: wrap;
}

.payment-item {
  border: 1px solid #d8e0e6;
  border-radius: 8px;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-out;
  background-color: #fdfefe;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 4px 15px rgba(64, 158, 255, 0.15);
  }

  &.active {
    border-color: #409eff;
    background-color: #eaf5ff;
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.25);
  }

  .payment-logo {
    width: 65px;
    height: 65px;
    margin-bottom: 18px;
    object-fit: contain;
  }

  span {
    font-size: 19px;
    color: #333d4b;
    font-weight: 600;
  }
}

.new-order-summary {
  width: 100%;
  max-width: 600px;
  text-align: center;
  margin-top: 40px;

  .summary-details {
    font-size: 20px;
    color: #333d4b;
    margin-bottom: 30px;

    .final-price {
      font-size: 38px;
      color: #e65100;
      font-weight: 800;
      margin-left: 12px;
    }
  }

  .el-button {
    min-width: 250px;
    height: 60px;
    font-size: 22px;
    font-weight: 600;
    border-radius: 30px;
    background: linear-gradient(135deg, #1f5f9e 0%, #3a7cb8 100%);
    border: none;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-out;

    &:hover:not(:disabled) {
      transform: translateY(-3px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
      background: linear-gradient(135deg, #3a7cb8 0%, #1f5f9e 100%);
    }

    &:disabled {
      background: #b0b8c4;
      cursor: not-allowed;
      box-shadow: none;
      opacity: 0.6;
    }
  }

  .payment-hint {
    margin-top: 25px;
    font-size: 15px;
    color: #e65100;
  }
}


.payment-success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 50px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 500px;
  margin: auto;
  box-sizing: border-box;

  .success-icon {
    font-size: 80px;
    color: #67c23a;
    /* El-ement UI 成功色 */
    margin-bottom: 20px;
  }

  .error-icon {
    font-size: 80px;
    color: red;
    /* El-ement UI 成功色 */
    margin-bottom: 20px;
  }

  .success-title {
    font-size: 28px;
    color: #333;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .success-message {
    font-size: 18px;
    color: #666;
    line-height: 1.6;
  }

  .success-actions {
    display: flex;
    gap: 20px;

    .action-button {
      padding: 12px 25px;
      font-size: 16px;
      border-radius: 5px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: none;
      outline: none;

      &.primary-button {
        background-color: #409eff;
        /* El-ement UI 主色 */
        color: #fff;

        &:hover {
          background-color: #66b1ff;
        }
      }

      &.secondary-button {
        background-color: #f4f4f5;
        /* El-ement UI 灰色 */
        color: #909399;
        border: 1px solid #dcdfe6;

        &:hover {
          background-color: #ebeef5;
          border-color: #cdd0d6;
        }
      }
    }
  }
}
</style>
